import axios from "axios";
import Env from "../env/Env";
import { defaultRequestHeaders } from "../consts/shared";
import { getActiveTenantId } from "../store/tenantStore";

const request = axios.create({
  timeout: 300000,
  headers: {
    ...defaultRequestHeaders,
  },
});

request.interceptors.request.use((config) => {
  const currentTenant = (config as any).tenantId || getActiveTenantId();
  const apiBase = Env.API_BASE;
  config.baseURL = `${apiBase}/api/admins/auth`;
  config.headers = config.headers || {};
  config.headers["x-tenant-id"] = currentTenant;
  config.headers["client"] = currentTenant;
  return config;
});

const authAPIsService = {
  validateMyakoToken: (token: string, tenantId?: string): Promise<{
    internalToken: string, organisationId: string, role: string, redirect_url?: string, tenantId?: string,
  }> => {
    return new Promise((resolve, reject) => {
      request
        .post("/", { token }, { tenantId } as any)
        .then(({ data }) => resolve(data))
        .catch((err) => reject(err?.response?.data?.errors || []));
    });
  },
};

export default authAPIsService;
